import { BaseMmsEntityServiceInterface } from "interfaces/base-entity-service-interface"
import { CommunicationService } from "services/mms/mock/CommunicationService"
import { useFetchMock } from "mock/useFetchMock"
import { FetchMockProps } from "types/mms-base"

// Define a top-level custom hook wrapper so Hooks are not called from within a class.
// This satisfies react-hooks/rules-of-hooks because the hook call happens at module scope
// inside a function starting with `use`, not inside a class method.
export const useFetchMockService = (props: FetchMockProps): FetchApiProps => {
    return useFetchMock(props)
}

export class BaseMmsMockService
    implements BaseMmsEntityServiceInterface<FetchMockProps>
{
    communicationService: CommunicationService
    delay: number
    protected constructor(communicationService: CommunicationService) {
        this.communicationService = communicationService
        this.delay = communicationService.delay
    }

    public useFetchService = useFetchMockService
    
    public get = useFetchMockService
    public post = useFetchMockService
    public put = useFetchMockService
    public patch = useFetchMockService
    public delete = useFetchMockService
}
